import Image from "next/image";
import Head from "next/head";

export default function Rental() {
  return (
    <div className="bg-white text-black">
      <Head>
        <title>Nous louons - Montransfert</title>
      </Head>

      <div className="bg-white">
        {/* Banner Section */}
        <div className="relative w-full h-[400px]">
          <Image
            src="/images/Car-Rental.webp"
            alt="Car rental"
            fill
            className="object-cover"
            quality={100}
          />

          <div className="absolute inset-0 bg-black/50"></div>

          <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white">
            <h1 className="text-5xl font-bold">Nous louons</h1>
          </div>
        </div>

        {/* Rental Transport Section */}
        <div className="mt-20 container mx-auto">
          <h2 className="text-4xl text-center font-semibold text-black mb-2">
            Une grande variété d&apos;options
          </h2>

          <h2 className="text-lg text-center uppercase tracking-widest text-[#deba91] mb-6">
            Les meilleures possibilités
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-7xl mx-auto w-[90%]">
            {/* Hybrid Toyota Auris Touring Hybrid */}
            <div className="flex flex-col">
              <div className="relative w-full h-[300px]">
                <Image
                  src="/images/car.jpg"
                  alt="Hybrid Toyota Auris Touring Hybrid"
                  fill
                  className="object-cover rounded-lg"
                />
              </div>

              <div className="mt-6">
                <h2 className="text-2xl text-center font-semibold text-black">
                  Hybrid Toyota Auris Touring Hybrid
                </h2>
                <h2 className="text-[16px] text-center uppercase tracking-widest text-[#deba91] pb-10">
                  Contactez-nous pour un devis gratuit
                </h2>
              </div>
            </div>

            {/* Van Rental */}
            <div className="flex flex-col">
              <div className="relative w-full h-[300px]">
                <Image
                  src="/images/van.jpg"
                  alt="Van Rental"
                  fill
                  className="object-cover rounded-lg"
                />
              </div>

              <div className="mt-6">
                <h2 className="text-2xl text-center font-semibold text-black">
                  Camionnette
                </h2>
                <h2 className="text-[16px] text-center uppercase tracking-widest text-[#deba91] pb-10">
                  Contactez-nous pour un devis gratuit
                </h2>
              </div>
            </div>

            {/* Third Item - Centered Second Row */}
            <div className="md:col-span-2 flex justify-center">
              <div className="w-full md:w-[48%] flex flex-col">
                <div className="relative w-full h-[300px]">
                  <Image
                    src="/images/third.jpg"
                    alt="Iveco daily"
                    fill
                    className="object-cover rounded-lg"
                  />
                </div>

                <div className="mt-6">
                  <h2 className="text-2xl text-center font-semibold text-black">
                    Camionnettes Iveco daily 35C17
                  </h2>
                  <h2 className="text-[16px] text-center uppercase tracking-widest text-[#deba91] pb-10">
                    Prix 150 chf / 100 km inclus / 0.50 chf km supplémentaires
                  </h2>
                </div>
              </div>
            </div>

            {/* ================================================= */}
            {/* ADDITIONAL CAMIONNETTE #1 */}
            {/* ================================================= */}
            <div className="flex flex-col">
              <div className="relative w-full h-[300px]">
                <Image
                  src="/images/2c.jpeg"
                  alt="Camionnette"
                  fill
                  className="object-cover rounded-lg"
                />
              </div>

              <div className="mt-6">
                <h2 className="text-2xl text-center font-semibold text-black">
                  Camionnette
                </h2>

                <h2 className="text-[16px] text-center uppercase tracking-widest text-[#deba91] pb-10">
                  Contactez-nous pour un devis gratuit
                </h2>
              </div>
            </div>

            {/* ================================================= */}
            {/* ADDITIONAL CAMIONNETTE #2 */}
            {/* ================================================= */}
            <div className="flex flex-col">
              <div className="relative w-full h-[300px]">
                <Image
                  src="/images/1c.jpeg"
                  alt="Camionnette"
                  fill
                  className="object-cover rounded-lg"
                />
              </div>

              <div className="mt-6">
                <h2 className="text-2xl text-center font-semibold text-black">
                  Camionnette
                </h2>

                <h2 className="text-[16px] text-center uppercase tracking-widest text-[#deba91] pb-10">
                  Contactez-nous pour un devis gratuit
                </h2>
              </div>
            </div>

            {/* ================================================= */}
            {/* ADDITIONAL CENTERED ITEM */}
            {/* ================================================= */}
            <div className="md:col-span-2 flex justify-center">
              <div className="w-full md:w-[48%] flex flex-col">
                <div className="relative w-full h-[300px]">
                  <Image
                    src="/images/4c.jpeg"
                    alt="Camionnette"
                    fill
                    className="object-cover rounded-lg"
                  />
                </div>

                <div className="mt-6">
                  <h2 className="text-2xl text-center font-semibold text-black">
                    Camionnette
                  </h2>

                  <h2 className="text-[16px] text-center uppercase tracking-widest text-[#deba91] pb-10">
                    Contactez-nous pour un devis gratuit
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}